import { zero_pad as e } from "../../calendar-carburettor/zero-pad/index.js";
// src/design/forms/datepicker/calendar-engine/utilities/stitch_date.ts
var t = (t, n = "-") => `${t.year}${n}${e(t.month)}${n}${e(t.day)}`;
export { t as stitch_date };

//# sourceMappingURL=stitch_date.js.map